<desy-pagination
  [totalItems]="totalItems"
  [itemsPerPage]="paginationSize"
  (itemsPerPageChange)="cambiarPageSize($event)"
  (currentPageChange)="cambiarPagina($event)"
  [hasSelect]="true"
  [currentPage]="currentPage"
  [showFirst]="true"
  [showLast]="true" />
